import type { FC, SVGAttributes } from 'react';

const Logo: FC<SVGAttributes<Record<string, unknown>>> = ({ width = 38, className, fill = '#1255E5' }) => {
  return (
    <svg fill="none" viewBox="0 0 38 33" width={width} preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path
        d="M24.4588 13.362C21.422 14.3743 16.3606 16.1964 10.4895 16.6013C9.27473 16.8037 8.26246 15.3865 9.07228 14.1718L16.5631 1.21473C17.5754 -0.404909 19.8024 -0.404909 20.8146 1.21473L22.2318 3.64418L25.876 9.71782C26.4834 11.135 25.876 12.7546 24.4588 13.362Z"
        fill={fill}
      />
      <path
        d="M34.7842 33H2.39149C0.569403 33 -0.645324 30.9755 0.366949 29.3558L4.01113 22.8773C5.0234 21.2577 6.8455 20.2454 8.66759 20.4478C17.1707 21.2577 22.4345 19.638 28.5081 18.2208C29.5204 18.0184 30.5327 18.4233 31.14 19.4356L37.0112 29.5583C37.821 30.9755 36.6063 33 34.7842 33Z"
        fill={fill}
      />
    </svg>
  );
};

export default Logo;
